import React, { memo } from "react";
import PropTypes from "prop-types";
import { Box, DialogContent, useMediaQuery, useTheme, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { CommonUtils } from "utils";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";
import clsx from "clsx";
import { Dialog, DialogContentText, DialogTitle } from "./components.style";

const ConfirmDialog = ({
  title,
  content,
  submitProps: { submitText, isLoading, ...otherSubmitProps },
  cancelProps: { cancelText, ...otherCancelProps },
  ...otherProps
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isFullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { t: getLabel } = useTranslation();
  const primaryContent = CommonUtils.isString(content) ? (
    <DialogContentText variant="body2" className={classes.contentText}>
      {content}
    </DialogContentText>
  ) : (
    content
  );

  return (
    <Dialog fullScreen={isFullScreen} classes={{ paper: classes.root }} {...otherProps}>
      <DialogTitle>{title || ""}</DialogTitle>
      <DialogContent className={classes.contentRoot}>{primaryContent}</DialogContent>

      <Box className={classes.action}>
        <Button color="primary" variant="contained" disabled={isLoading} fullWidth {...otherSubmitProps}>
          {submitText || getLabel(LangConstant.L_DELETE_USER_BUTTON)}
          {isLoading && <Box className={clsx("loader", classes.loading)} />}
        </Button>

        <Button variant="outlined" fullWidth {...otherCancelProps}>
          {cancelText || getLabel(LangConstant.L_CANCEL)}
        </Button>
      </Box>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  submitProps: PropTypes.object,
  cancelProps: PropTypes.object,
};
ConfirmDialog.defaultProps = {
  submitProps: {},
  cancelProps: {},
};

export default memo(ConfirmDialog);

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1.5, 3),
    textAlign: "center",
    color: "#000000",
    minWidth: 543,
  },

  contentRoot: {
    padding: 0,
  },

  action: {
    marginTop: 16,

    "& > *": {
      marginTop: 6,
      marginBottom: 6,
    },
    "& > *:last-child": { marginTop: 12, color: "#000000" },
  },

  loading: {
    width: 20,
    marginLeft: 8,
  },
}));
